import { combineReducers } from 'redux';
import usersReducer from './usersReducer';
import authReducer from './authReducer';
import adminsReducer from './adminsReducer';
import tourReducer from './tourReducer';
import roomsReducer from './roomsReducer';
import facilitiesReducer from './facilitiesReducer';
import caresReducer from './caresReducer';
import newsReducer from './newsReducer';
import coreReducer from './coreReducer';
import homeReducer from './homeReducer';
import contactusReducer from './contactusReducer';
import educationsReducer from "./educationsReducer";


export default combineReducers({
    home: homeReducer,
    users: usersReducer,
    auth: authReducer,
    admins: adminsReducer,
    tour: tourReducer,
    rooms: roomsReducer,
    facilities: facilitiesReducer,
    cares: caresReducer,
    news: newsReducer,
    core: coreReducer,
    contactus: contactusReducer,
    educations: educationsReducer
});


// WEBPACK FOOTER //
// ./src/client/reducers/index.js